import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AuctionService } from '../../_services/auction/auction.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { BuyerAuthService } from 'src/app/app-modules/buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IHorse } from 'src/app/app-modules/seller/seller-modules/auctions/_interfaces/horse.interface';
import {
  BehaviorSubject,
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  forkJoin,
} from 'rxjs';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import { MatDialog } from '@angular/material/dialog';
import { BiddingNowPopupComponent } from '../../../../buyer-shared/components/bidding-now-popup/bidding-now-popup.component';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { BuyerService } from 'src/app/app-modules/buyer/_services/buyer/buyer.service';
import { Meta, Title } from '@angular/platform-browser';
import { BidIncrementsComponent } from 'src/app/app-modules/buyer/buyer-shared/components/bid-increments/bid-increments.component';
import { environment } from 'src/environments/environment';
import { NotificationWindowService } from 'src/app/Shared/_services/notification/notification.service';
import {
  changeAuctionItemStatus,
  changeAuctionsStatuses,
} from 'src/app/_utlis/auctions-helpers';
import {
  CardsPerPage,
  getPaginationData,
  ItemsPerPage,
} from 'src/app/_utlis/pagination-helper';
import { BuyerCataloguePageheaderComponent } from '../../components/buyer-catalogue-pageheader/buyer-catalogue-pageheader.component';
import { BreadCrumbsComponent } from '../../../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { BuyerPageOptionsComponent } from '../../../../buyer-shared/components/buyer-page-options/buyer-page-options.component';
import { SearchInputComponent } from '../../../../../../Shared/components/search/search-input.component';
import { PaginationResultsComponent } from '../../../../../../Shared/components/pagination-results/pagination-results.component';
import {
  NgClass,
  CommonModule,
  DatePipe,
  ViewportScroller,
} from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { BuyerCatalogueCardComponent } from '../../components/buyer-catalogue-card/buyer-catalogue-card.component';
import { PaginationComponent } from '../../../../../../Shared/components/pagination/pagination.component';
import { SearchPipe } from '../../../../../../Shared/_pipes/search.pipe';
import { isPlatformBrowser } from '@angular/common';
import { BaseTableComponent } from '../../../../../../Shared/components/base-table/base-table.component';
import { Column } from 'src/app/Shared/_models/column';
import { TimeLeftCellComponent } from 'src/app/Shared/components/time-left-cell/time-left-cell.component';
import { MatButtonModule } from '@angular/material/button';
import { RequestToBidButtonComponent } from 'src/app/app-modules/buyer/buyer-shared/components/request-to-bid-button/request-to-bid-button.component';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { AuctionItemStatusComponent } from 'src/app/app-modules/buyer/buyer-shared/components/auction-item-status/auction-item-status.component';
import { TimerComponent } from 'src/app/Shared/components/timer/timer.component';
import { HorseStatusDisplayService } from 'src/app/app-modules/buyer/buyer-shared/services/horse-status-display.service';
import { BidNowButtonComponent } from 'src/app/app-modules/buyer/buyer-shared/components/bid-now-button/bid-now-button.component';
import { TermsAndConditionsAcceptanceService } from 'src/app/app-modules/buyer/buyer-shared/services/terms-and-conditions-acceptance.service';
import { IChannel } from 'src/app/Shared/_models/channel.model';
import * as Events from 'src/app/_contstants/pusher-contstants';
import { PusherSubscriptionService } from 'src/app/app-modules/buyer/buyer-shared/services/pusher-subscription/pusher-subscription.service';
import { CatalogueFiltersComponent } from '../../components/catalogue-filters/catalogue-filters.component';
import {
  FilterField,
  StaticFilters,
  transformStaticFilters,
} from 'src/app/_utlis/filters';
import { MakeOfferBtnComponent } from 'src/app/app-modules/buyer/buyer-shared/components/make-offer-btn/make-offer-btn.component';
import { CustomCurrencyPipe } from 'src/app/Shared/_pipes/currency-pipe/custom-currency-pipe.pipe';
import { CatalogueStatsDialogComponent } from '../../components/catalogue-stats-dialog/catalogue-stats-dialog.component';
import { AuctionItemCardComponent } from '../../../../buyer-shared/components/auction-item-card/auction-item-card.component';
import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';
import { NoDataComponent } from 'src/app/Shared/components/no-data/no-data.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LiveVideoService } from '../../_services/live-video/live-video.service';
import { LiveVideoPlayerComponent } from '../../components/live-video-player/live-video-player.component';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
import { LanguageService } from 'src/app/Shared/services/language/language.service';
import { TranslationUpdater } from 'src/app/Shared/helpers/translation-updater';
import { LocalizedNamePipe } from 'src/app/Shared/pipes/localized-name.pipe';
import { HorseNamePipe } from 'src/app/Shared/_pipes/horse-name.pipe';
import { RolloverRefreshCoordinator } from '../../../../buyer-shared/utils/rollover-refresh-coordinator';

@Component({
  selector: 'app-buyer-catalogue',
  standalone: true,
  templateUrl: './buyer-catalogue-new.component.html',
  styleUrls: ['./buyer-catalogue-new.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    BuyerCataloguePageheaderComponent,
    BreadCrumbsComponent,
    PaginationResultsComponent,
    NgClass,
    ReactiveFormsModule,
    PaginationComponent,
    SearchPipe,
    BaseTableComponent,
    MatButtonModule,
    RequestToBidButtonComponent,
    CommonModule,
    AuctionItemStatusComponent,
    TimerComponent,
    BidNowButtonComponent,
    CatalogueFiltersComponent,
    MakeOfferBtnComponent,
    AuctionItemCardComponent,
    SkeletonLoaderComponent,
    NoDataComponent,
    MatTooltipModule,
    LiveVideoPlayerComponent,
    TranslatePipe,
    HorseNamePipe,
  ],
  providers: [DatePipe, CustomCurrencyPipe, LocalizedNamePipe],
})
export class BuyerCatalogueComponent implements OnDestroy {
  isLoading: boolean = false;
  searchVal: string = '';
  catalogData: any[] = [];
  auctionType: string = '';
  @ViewChild('auctionNameTemplate', { static: true })
  auctionNameTemplate!: TemplateRef<any>;
  @ViewChild('actionsTemplate', { static: true })
  actionsTemplate!: TemplateRef<any>;
  @ViewChild('timeLeftTemplate', { static: true })
  timeLeftTemplate!: TemplateRef<any>;

  containsImg: { with_property: string; img_property_name: string } = {
    with_property: 'name',
    img_property_name: 'image',
  };
  auctionItemsIDs: number[] = [];
  auctionId!: number;
  loggedIn!: boolean;
  channel: any;
  timer!: any;
  calledFirstTime!: boolean;
  // bidsIncrements!: { from: number; to: number; bid: number }[];
  breadcrumbs!: Breadcrumb[];
  auction: any;
  auctionTypeParams!: string;
  isCardLayout: boolean = true; // Default to card layout
  categoryCounts: any;
  selectedCategory: string = '';
  selectedSex: string = '';
  consignorName!: string;
  auc_type: any;
  horsesSex: any;
  translation!: any;
  catalogueTranslation: any = {};
  currentLang: any;
  slug = '';
  auctionSettings: any;
  user_id!: number;
  page: number = 1;
  itemsPerPage: number = CardsPerPage;

  paginationData!: {
    totalPages: number;
    total: number | undefined;
    from: number | undefined;
    to: number | undefined;
  };
  isBrowser: boolean;
  tableColumns: Array<Column> = [];
  staticFilters: StaticFilters = {};
  private isLoadingState = new BehaviorSubject<boolean>(false);
  isLoadingState$ = this.isLoadingState.asObservable();
  private selectedFilters = new BehaviorSubject<any>(null);
  selectedFilters$ = this.selectedFilters.asObservable();
  isExpanded = false;
  filterFields: FilterField[] = [];
  dynamicFilters: { [key: string]: any[] } = {};
  private filtersInitialized = false;
  auctionIdParams!: string;
  consignorId: any;

  private auctionItemUpdateSubject = new Subject<any>();
  private pusherSubscriptions: any[] = [];
  private isSubscribed = false;
  private translationUpdater?: TranslationUpdater;
  isDev: boolean = environment.isDev;

  // Store all RxJS subscriptions for cleanup
  private subscriptions: Subscription[] = [];

  // Track bound Pusher events for cleanup
  private boundPrivateEvents: string[] = [];
  private boundPublicEvents: string[] = [];
  private rolloverRefreshCoordinator = new RolloverRefreshCoordinator(2000);
  private lastRefreshTimestamp = 0;
  private readonly REFRESH_COOLDOWN_MS = 3000;

  constructor(
    private auctionService: AuctionService,
    private toastService: ToastService,
    private auth: BuyerAuthService,
    private router: Router,
    private route: ActivatedRoute,
    private pusherService: PusherService,
    private dialog: MatDialog,
    private storage: StorageService,
    private buyerService: BuyerService,
    private titleService: Title,
    private translate: TranslateService,
    private notification: NotificationWindowService,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private termsAcceptance: TermsAndConditionsAcceptanceService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private pusherSubscriptionService: PusherSubscriptionService,
    private viewportScroller: ViewportScroller,
    private customCurrencyPipe: CustomCurrencyPipe,
    private liveVideoService: LiveVideoService,
    public localeService: LocaleService,
    private languageService: LanguageService,
    private localizedNamePipe: LocalizedNamePipe,
    private statusService: HorseStatusDisplayService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  saveScrollPosition() {
    const scrollPosition = this.viewportScroller.getScrollPosition();
    sessionStorage.setItem(
      this.storage.getPrefixedKey('scrollPosition'),
      JSON.stringify(scrollPosition),
    );
  }

  restoreScrollPosition() {
    const savedPosition = sessionStorage.getItem(
      this.storage.getPrefixedKey('scrollPosition'),
    );
    if (savedPosition) {
      const [x, y] = JSON.parse(savedPosition);
      setTimeout(() => {
        this.viewportScroller.scrollToPosition([x, y]);
      }, 1);
    }
  }
  initCols() {
    const bidCol =
      this.auctionType == 'upcoming'
        ? 'horse_info.starting_bid'
        : this.auctionType == 'previous'
          ? 'horse_info.latest_bid'
          : 'horse_info.current_bid';

    this.tableColumns = [
      {
        columnDef: 'hip',
        header: this.translate.instant('horse_info.hip'),
        translationKey: 'horse_info_hip',
        cell: (element: Record<string, any>) => element['hip'],
        template: false,
        templateRef: null,
      },
      {
        columnDef: 'name',
        header: this.translate.instant('horse_info.name'),
        translationKey: 'horse_info_name',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.auctionNameTemplate,
      },
      {
        columnDef: 'Sire',
        header: this.translate.instant('horse_info.sire'),
        translationKey: 'horse_info_sire',
        cell: (element: Record<string, any>) => element['Sire'],
        template: false,
        templateRef: null,
      },

      {
        columnDef: 'Dam',
        header: this.translate.instant('horse_info.dam'),
        translationKey: 'horse_info_dam',
        cell: (element: Record<string, any>) => element['Dam'],
        template: false,
        templateRef: null,
      },

      {
        columnDef: 'bornData',
        header: this.translate.instant('horse_info.born'),
        translationKey: 'horse_info_born',
        cell: (element: Record<string, any>) =>
          this.datePipe.transform(element['bornData'], 'dd/MM/yyyy'),
        template: false,
        templateRef: null,
      },

      ...(this.isDev
        ? [
            {
              columnDef: 'highest_bid_amount',
              header: this.translate.instant(bidCol),
              translationKey: bidCol.replace('.', '_'),
              cell: (element: Record<string, any>) =>
                element['status'] === 'no_status'
                  ? '----'
                  : this.customCurrencyPipe.transform(
                  (this.auctionType == 'upcoming'
                    ? element['min_bid']
                    : this.auctionType == 'previous' &&
                        element['display_price']?.amount != null
                      ? element['display_price'].amount
                      : element['highest_bid_amount']) ?? 0,
                  this.auctionType == 'previous'
                    ? element['display_price']?.currency ||
                        this.auction?.currency?.currency_code
                    : this.auction?.currency?.currency_code,
                  this.localeService.locale,
                  'symbol',
                  '1.0-0',
                ),
              template: false,
              templateRef: null,
            },
          ]
        : []),
      {
        columnDef: ' ',
        header: this.translate.instant('horse_info.actions'),
        translationKey: 'horse_info_actions',
        cell: (element: Record<string, any>) => null,
        template: true,
        templateRef: this.actionsTemplate,
      },
    ];
  }
  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        label: this.translate.instant('buyer_catalogue.home'),
        url: '/',
        translationKey: 'buyer_catalogue.home',
      },
      {
        label: ` ${
          this.auctionTypeParams !== 'my_auctions'
            ? this.translate.instant('buyer_catalogue.auctions')
            : this.translate.instant('buyer_catalogue.my_auctions')
        }`,
        url: `/buyer/${
          this.auctionTypeParams == 'my_auctions' ? 'account' : 'auctions'
        }/${
          this.auctionTypeParams !== 'my_auctions' ? 'list/all' : 'my-auctions'
        }`,
        translationKey:
          this.auctionTypeParams !== 'my_auctions'
            ? 'buyer_catalogue.auctions'
            : 'buyer_catalogue.my_auctions',
      },
      {
        label: this.translate.instant('buyer_catalogue.catalogue'),
        url: '',
        translationKey: 'buyer_catalogue.catalogue',
      },
    ];
  }
  // Parse query params for static filters
  private parseQueryParams(params: any): void {
    this.dynamicFilters = {};
    const filterKeys = ['sex', 'category', 'color'];

    // Handle search_term directly (not as filters[search_term])
    if (params['search_term']) {
      const value = Array.isArray(params['search_term'])
        ? params['search_term'][params['search_term'].length - 1]
        : params['search_term'];
      if (value) {
        this.dynamicFilters['search_term'] = [value];
      }
    }

    // Handle filters[key] format for other filters
    Object.keys(params).forEach((key) => {
      const match = key.match(/^filters\[(\w+)\]$/);
      if (match && filterKeys.includes(match[1])) {
        const filterKey = match[1];
        const filterValue = params[key];

        if (filterValue) {
          // Single-select: always take the last value if array
          const value = Array.isArray(filterValue)
            ? filterValue[filterValue.length - 1]
            : filterValue;
          this.dynamicFilters[filterKey] = [value];
        }
      }
    });

    this.selectedFilters.next(this.dynamicFilters);
  }
  ngOnInit(): void {
    this.subscriptions.push(
      this.auth.loggedIn_authorized$.subscribe((res) => {
        this.loggedIn = res;

        this.user_id = this.storage?.userData?.id;
        this.auctionItemUpdateDebouncing();
        this.subscribeToAuctionItemUpdated();
        this.subscribeToAuctionItemUpdatesUpdated();

        if (this.user_id) {
          this.subscribeToOfferUpdatesChannel();
          this.subscribeToBuyerApplicationsChannels();
          this.subscribeToPrivateTermsAndConditionsUpdated();
        } else {
          this.unSubscribeToPrivateUserChannel();
        }
        if (this.calledFirstTime) {
          this.getData();
        }
        // this.subscribeToAuctionChannel();
      }),
    );

    this.subscriptions.push(
      this.route.params.subscribe((p) => {
        this.slug = p['slug'];
        this.auctionIdParams = p['auction_id'];
      }),
    );

    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        this.auctionTypeParams = params['auctionTypePage'];
        this.page = +params['page'];
        this.searchVal = params['search'] || '';

        this.parseQueryParams(params);

        this.getData();
      }),
    );
    if (this.isBrowser) {
      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ??
          '{}',
      );
    }
  }
  ngAfterViewInit() {
    this.initCols();
    this.subscribeToAcceptedTerms();

    // Setup auto-updating translations for table headers
    this.translationUpdater = new TranslationUpdater(this.languageService, () =>
      this.updateTranslations(),
    );
  }
  subscribeToAcceptedTerms() {
    this.subscriptions.push(
      this.termsAcceptance.buyerAccepted$.subscribe((value) => {
        if (value?.isAccepted === 'accepted') {
          this.auction = {
            ...this.auction,
            buyer_accepted_seller_terms: value?.isAccepted,
          };
          this.cdr.detectChanges();
        }
      }),
    );
  }

  getData(loading = true): void {
    // Clear previous toast notifications
    this.toastService.clear();

    // Set loading state if applicable
    if (loading) {
      this.isLoading = true;
      this.isLoadingState.next(true);
    }
    const requests = [
      this.auctionService.getCatalogueDataBySlug(
        this.slug,
        this.auctionIdParams,
        this.searchVal,
        this.page || 1,
        this.itemsPerPage,
        this.dynamicFilters,
      ),
    ];

    forkJoin(requests).subscribe({
      next: ([result]) => {
        this.handleInitialSetup(result);
        this.updateCatalogueData(result);
        this.updateAuctionData(result);
        this.updatePaginationData(result.data.pagination);
        // BXS-3591: after any refetch (including the rollover refresh fired when
        // a card's countdown ends during gradual ending), re-apply the
        // closed-last ordering client-side. Runs after updateAuctionData so the
        // gradual_ending_settings guard sees the latest value.
        this.sortCatalogDuringGradualEnding();
      },
      error: (error) => {
        this.toastService.showError(
          error?.error?.Error?.[0] || 'An error occurred',
        );
      },
      complete: () => {
        this.isLoading = false;
        this.isLoadingState.next(false);
      },
    });
  }
  private handleInitialSetup(result: any): void {
    const { items: catalogueItems, auction, filters } = result.data;
    this.staticFilters = filters ?? {};

    // Only initialize filter fields once to prevent filter reload on search
    if (
      !this.filtersInitialized &&
      Object.keys(this.staticFilters).length > 0
    ) {
      this.filterFields = transformStaticFilters(
        this.staticFilters,
        this.dynamicFilters,
      );
      this.filtersInitialized = true;
    }

    // Set auction ID
    this.auctionId = auction?.id;
    // Add view count and subscribe to channels if it's the first time
    if (!this.calledFirstTime && this.isBrowser) {
      this.addViewCount();
      this.calledFirstTime = true;
    }

    // Set consignor name
    this.consignorName = auction?.seller;
    this.consignorId = auction?.seller_id;

    // Determine auction type and set breadcrumbs
    const auctionSetting = catalogueItems?.[0]?.auction_settings;
    if (auctionSetting) {
      this.auctionSettings = auctionSetting;
      this.determineAuctionType(auctionSetting);
    } else {
      // Fallback: determine from dates when auction_settings not available (empty catalogue)
      // Use current time as fallback if current_datetime is not provided by API
      const currentDateTime =
        result.data.current_datetime || new Date().toISOString();
      this.determineAuctionTypeFromDates(
        currentDateTime,
        auction?.auction_start_date,
        auction?.extended_end_date,
      );
      // Create minimal auction_settings for components that need it
      this.auctionSettings = {
        running: this.auctionType === 'active',
        ended: this.auctionType === 'previous',
      };
    }
    if (!this.auctionTypeParams) {
      this.setBreadcrumbs();
    }
  }

  private determineAuctionType(settings: any): void {
    const { ended, running } = settings;

    if (running && !ended) {
      this.auctionType = 'active';
      // this.addTimeLeftColumn();
    } else if (!running && ended) {
      this.auctionType = 'previous';
    } else if (!running && !ended) {
      this.auctionType = 'upcoming';
    } else {
      this.auctionType = 'previous';
    }
    // Re-initialize columns with updated auction type
    this.initCols();
  }

  private determineAuctionTypeFromDates(
    currentDate: string,
    auctionStartDate: string,
    extendedEndDate: string,
  ): void {
    const now = new Date(currentDate);
    const start = new Date(auctionStartDate);
    const end = new Date(extendedEndDate);

    if (now < start) {
      this.auctionType = 'upcoming';
    } else if (now >= start && now < end) {
      this.auctionType = 'active';
    } else {
      this.auctionType = 'previous';
    }
    this.initCols();
  }

  private addTimeLeftColumn(): void {
    const timeLeftColumnExists = this.tableColumns.some(
      (col) => col.columnDef === 'time_left',
    );

    if (!timeLeftColumnExists) {
      const timeLeftColumn = {
        columnDef: 'time_left',
        header: this.translate.instant('horse_info.time_left') || '',
        cell: (element: Record<string, any>) => element['time_left'],
        template: true,
        templateRef: this.timeLeftTemplate,
      };

      const actionsIndex = this.tableColumns.findIndex(
        (col) => col.columnDef === ' ',
      );
      if (actionsIndex !== -1) {
        this.tableColumns.splice(actionsIndex, 0, timeLeftColumn);
      } else {
        this.tableColumns.push(timeLeftColumn);
      }
    }
  }
  private updateCatalogueData(result: any): void {
    const {
      items: catalogueItems,
      current_datetime: currentDate,
      filters,
    } = result.data;

    this.catalogData = catalogueItems.map((item: any) => ({
      auc_id: this.auctionId,
      id: item?.id,
      name: item.horse.name,
      hip: item.hip_number,
      bornData: item.horse?.date_of_birth,
      Sire: item.horse?.sire,
      Dam: item.horse?.dam,
      'Sire of Dam': item.horse?.sire_of_dam,
      image: item?.auction_pictures?.[0]?.url || '',
      Sex: item.horse?.sex,
      consignor: item?.created_by_user_name,
      Category: item.horse?.category,
      winner_user_id: item.winner_user_id,
      can_bid: item.auction_item_settings?.can_bid,
      in_user_wishlist: item.auction_item_settings?.in_user_wishlist,
      is_this_user_winner: item.auction_item_settings?.is_this_user_winner,
      wishlistClicked: false,
      highest_bid_amount: item.highest_bid?.amount || null,
      display_price: item.display_price ?? null,
      buyer_name: item.buyer_name ?? null,
      bids_count: item?.bids_count ?? 0,
      min_bid: item.min_bid,
      current: currentDate,
      slug: item.slug,
      aucSlug: item?.auction?.slug,
      buyer_document_categories: item.buyer_document_categories,
      rna_status_offers:
        (this.statusService.isRNA(item) && this.auctionType !== 'previous') ||
        (this.statusService.isRNA(item) &&
          this.auctionType == 'previous' &&
          !item?.make_an_offer?.is_available &&
          item?.make_an_offer.time_window_days == 0),
      rna_status: this.statusService.isRNA(item),
      reserve_price: item.reserve_price,
      winnerUser: this.statusService.isWinner(item),
      soldUser:
        this.statusService.isSold(item) ||
        item?.make_an_offer?.item_has_accepted_offer,

      unSold:
        this.statusService.isNotSold(item) ||
        (!item?.status &&
          item?.unsold_flag_at !== null &&
          !this.statusService.isRNA(item)),
      unSold_offers:
        (this.statusService.isNotSold(item) &&
          this.auctionType !== 'previous' &&
          !this.statusService.isRNA(item)) ||
        (this.statusService.isNotSold(item) &&
          this.auctionType == 'previous' &&
          !item?.make_an_offer?.is_available &&
          item?.make_an_offer.time_window_days == 0 &&
          !this.statusService.isRNA(item)),
      winner: item?.winner,
      expired: item?.expired,
      unsold_flag_at: item.unsold_flag_at,
      auction_start_date: item?.auction?.auction_start_date,
      extended_end_date: item?.extended_end_date,
      offers: item?.offers,
      make_an_offer: item?.make_an_offer,
      withdrawn_at: item?.withdrawn_at,
      status: item?.status,
      has_update: item?.has_update,
      update_content: item?.update_content,
    }));

    // Update category counts and sex list
    this.categoryCounts = this.countItemsByCategory(filters?.categories);
    this.getSexList(filters?.sexes);
  }

  private updateAuctionData(result: any): void {
    const {
      items: catalogueItems,
      auction,
      auction: { gradual_ending_settings, extended_end_date },
    } = result.data;
    // Use current time as fallback if current_datetime is not provided by API
    const currentDate =
      result.data.current_datetime || new Date().toISOString();

    const auctionItem = catalogueItems?.[0];
    this.auction = {
      auction: {
        ...auctionItem?.auction,
        image: auction?.image?.url,
        // Ensure auction_start_date is always available (for empty catalogue countdown)
        auction_start_date:
          auctionItem?.auction?.auction_start_date ||
          auction?.auction_start_date,
        // Ensure name is always available (for empty catalogue header display)
        name: auctionItem?.auction?.name || auction?.name,
      },
      auction_settings: auctionItem?.auction_settings
        ? { ...auctionItem.auction_settings }
        : { ...this.auctionSettings },
      currentDate,
      auc_type: this.auctionType,
      gradual_ending_settings,
      extended_end_date,
      ...auction,
    };
    if (this.breadcrumbs?.[2]) {
      this.breadcrumbs[2].label =
        this.localizedNamePipe.transform(this.auction?.name) +
        ' ' +
        this.translate.instant('buyer_catalogue.catalogue');
    }

    // Check for livestream data and set it
    this.checkAndSetLiveVideo(result.data);
  }

  private checkAndSetLiveVideo(data: any) {
    if (data?.auction?.livestream?.ivs_playback_url) {
      this.liveVideoService.setLiveVideo({
        ivs_playback_url: data.auction.livestream.ivs_playback_url,
        auction_name: data.auction.name,
        auction_id: data.auction.id,
      });
    }
  }

  private updatePaginationData(pagination: any): void {
    this.paginationData = getPaginationData(pagination, this.itemsPerPage);
  }
  onFavoriteClick(auctionItem: any): void {
    this.toggleAddToWishlist(auctionItem?.id);
  }

  countItemsByCategory(data: any): any {
    if (data) {
      const totalCount: number = data.reduce(
        (sum: number, item: { count: number }) => sum + item.count,
        0,
      );
      data.unshift({ category: 'All', count: totalCount });
      return data;
    }

    return [];
  }
  getSexList(data: any) {
    if (data) {
      this.horsesSex = ['All', ...data.map((item: { sex: any }) => item.sex)];
    }
  }

  handleActions(
    $event: any,
    e: { propagation?: string; action: string; id: number },
  ) {
    const { action, id, propagation } = e;

    if (propagation) {
      $event.stopPropagation();
    }

    switch (action) {
      case 'fav':
        this.toggleAddToWishlist(id);
        break;
      case 'view':
        const item = this.catalogData.find((el) => el?.id == id);

        this.router.navigate(
          ['/buyer/auctions', item.aucSlug, 'horse', item.slug],
          {
            state: { auctionTypePage: this.auctionTypeParams },
            queryParams: {
              type: 'catalogue',
            },
          },
        );
        break;
      case 'time_ended':
        this.scheduleRolloverFallback();
        break;
    }
  }

  bidNowClicked(id: number) {
    if (this.loggedIn) {
      this.dialog.open(BiddingNowPopupComponent, {
        width: '850px',
        height: '650px',
        direction: this.localeService.dir,
        panelClass: ['buyer-theme'],

        data: { id },
      });
    } else {
      this.buyerService.setShowLogin(true);
    }
  }
  toggleAddToWishlist(id: number) {
    this.toastService.clear();

    if (this.loggedIn) {
      const auction_item = this.catalogData.find((el) => el?.id == id);

      auction_item.wishlistClicked = true;
      let req;
      let message = '';
      if (auction_item.in_user_wishlist) {
        //remove
        req = this.auctionService.deleteFromWishlist(id);
        message = this.translate.instant(
          'messages.success.removed_from_wishlist',
        );
      } else {
        //add
        req = this.auctionService.addToWishlist(id);
        message = this.translate.instant('messages.success.added_to_wishlist');
      }
      req.pipe().subscribe({
        next: () => {
          auction_item.wishlistClicked = false;
          this.toastService.showSuccess(message);
          auction_item.in_user_wishlist = !auction_item.in_user_wishlist;
        },
        error: (error) => {
          auction_item.wishlistClicked = false;

          this.toastService.showError(error?.error?.Error[0]);
        },
      });
    } else {
      this.buyerService.setShowLogin(true);
    }
  }

  handleSearch(e: any) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.searchVal = e.target.value.trim();
      const queryParams: any = {
        ...this.route.snapshot.queryParams,
        search: this.searchVal,
      };

      if (this.auctionIdParams) {
        this.router.navigate([`/buyer/auctions/id/${this.auctionIdParams}`], {
          queryParams,
        });
      } else if (this.slug) {
        this.router.navigate([`/buyer/auctions/${this.slug}`], {
          queryParams,
          replaceUrl: true,
        });
      }
    }, 1500);
  }

  onPageChanged(page: number): void {
    const queryParams = {
      ...this.route.snapshot.queryParams, // Preserve all existing params
      page, // Update only the page number
    };

    if (this.auctionIdParams) {
      this.router.navigate([`/buyer/auctions/id/${this.auctionIdParams}`], {
        queryParams,
        replaceUrl: true,
      });
    } else if (this.slug) {
      this.router.navigate([`/buyer/auctions/${this.slug}`], { queryParams });
    }
  }
  resetSearch() {
    this.searchVal = '';
    const queryParams: any = {
      page: 1,
      search: this.searchVal,
      sex: this.selectedSex,
      category: this.selectedCategory,
      auctionTypePage: this.auctionTypeParams,
    };
    if (this.auctionIdParams) {
      this.router.navigate([`/buyer/auctions/id/${this.auctionIdParams}`], {
        queryParams,
      });
    } else if (this.slug) {
      this.router.navigate([`/buyer/auctions/${this.slug}`], { queryParams });
    }
  }
  addViewCount() {
    this.toastService.clear();

    this.auctionService.addAuctionViewCount(this.auctionId).subscribe(
      (res) => {},
      (err) => {
        this.toastService.showError(err.error.Error[0]);
      },
    );
  }
  sortItems(array1: any[], array2: any[]): any[] {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
      throw new Error('Both parameters must be arrays.');
    }

    const sortedArray = array1.sort((a, b) => {
      const indexA = array2.indexOf(a.id);
      const indexB = array2.indexOf(b.id);
      return indexA - indexB;
    });

    return sortedArray;
  }

  /**
   * BXS-3591: Client-side sort applied during the Gradual Ending phase only.
   *
   * Source of truth for ordering is still the backend's `sorted_auction_items_ids`
   * delivered via Pusher. This local sort is a defensive fallback that runs:
   *  - The instant a card's countdown expires (so the closed card moves to the
   *    end immediately, without waiting for the Pusher event / 2 s rollover).
   *  - As a safety net inside `handleAuctionUpdate` after a status flip, so the
   *    reorder happens even if a particular Pusher payload omits
   *    `sorted_auction_items_ids`.
   *
   * The sort key mirrors the backend SQL exactly:
   *   `CASE WHEN finish_processing_at IS NULL THEN 0 ELSE 1 END, extended_end_date ASC`
   * On the client we don't have `finish_processing_at`, but a non-null `status`
   * (set by the backend the moment the item closes) is the equivalent signal.
   * We also treat a passed `extended_end_date` as closed so timer-end gets an
   * instant reorder before the Pusher event arrives.
   */
  private sortCatalogDuringGradualEnding(): void {
    if (!Array.isArray(this.catalogData) || this.catalogData.length === 0) return;
    // BXS-3591: apply the closed-last ordering for any gradual-ending catalogue.
    // Detect that from staggered item close times (matching the backend), not
    // only the gradual_ending_settings flag — that flag stays null through the
    // whole closing window when the auction's extended_end_date equals the last
    // horse's close time, which would otherwise make this sort a no-op exactly
    // when it is needed.
    const distinctEndDates = new Set(
      this.catalogData.map((i) => i?.extended_end_date).filter(Boolean),
    );
    if (!this.auction?.gradual_ending_settings && distinctEndDates.size <= 1) {
      return;
    }

    const nowMs = this.auction?.currentDate
      ? new Date(this.auction.currentDate).getTime()
      : Date.now();

    const isClosed = (item: any): boolean => {
      // Server has marked it closed (status set in the Pusher payload).
      if (item?.status) return true;
      // Local timer fired before the Pusher event arrived — trust the
      // timer's signal so the card visually moves to the end immediately.
      if (item?._localExpired) return true;
      if (!item?.extended_end_date) return false;
      const end = new Date(item.extended_end_date).getTime();
      return Number.isFinite(end) && end <= nowMs;
    };

    const endMs = (item: any): number => {
      const t = item?.extended_end_date
        ? new Date(item.extended_end_date).getTime()
        : NaN;
      return Number.isFinite(t) ? t : Number.MAX_SAFE_INTEGER;
    };

    // Fully-ended auction: every horse has already closed, so the closed-last
    // reorder no longer surfaces anything biddable — it only scrambles the
    // catalogue by close time, pushing horses that took late bids (and were
    // extended past the rest) behind their hip order. Keep the backend order in
    // that case and only reorder while at least one horse is still live. Mirrors
    // the backend AuctionCatalogService active-horse gate (BXS-3591 follow-up).
    const hasActiveHorse = this.catalogData.some((item) => !isClosed(item));
    if (!hasActiveHorse) return;

    this.catalogData.sort((a, b) => {
      const aClosed = isClosed(a) ? 1 : 0;
      const bClosed = isClosed(b) ? 1 : 0;
      if (aClosed !== bClosed) return aClosed - bClosed;
      return endMs(a) - endMs(b);
    });
    this.catalogData = [...this.catalogData];
  }

  syncUpdates() {
    this.getData(true); // Re-fetch auction data
  }
  handleAuctionUpdate(data: any) {
    if (data?.auction_id == this.auctionId) {
      this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
        this.auctionId,
      );

      // Update auction-level gradual ending settings from Pusher events
      // This must happen regardless of whether the specific item is on the current page,
      // so the pageheader timer switches to next_item_finish_at during gradual ending
      if (data?.gradual_ending_settings !== undefined) {
        this.auction = {
          ...this.auction,
          gradual_ending_settings: data.gradual_ending_settings,
        };
      }
      if (data?.auction_end_date) {
        this.auction = {
          ...this.auction,
          extended_end_date: data.auction_end_date,
        };
      }
      if (data?.current_datetime) {
        this.auction = {
          ...this.auction,
          currentDate: data.current_datetime,
        };
      }

      // Re-sort catalogue items if sort order provided (e.g. during gradual ending transitions)
      if (data?.sorted_auction_items_ids) {
        const sortedCatalogData = this.sortItems(
          this.catalogData,
          data.sorted_auction_items_ids,
        );
        this.catalogData = [...sortedCatalogData];
      }
    }

    const exists = this.catalogData.find(
      (item: { id: any }) => item.id === data.auction_item_id,
    );
    if (data?.auction_id == this.auctionId && exists) {
      const item = this.catalogData.find(
        (el) => el?.id == data?.auction_item_id,
      );

      if (item) {
        // Update status from backend
        if (data.status) {
          item.status = data.status;
          item.rna_status = this.statusService.isRNA({ status: data.status });
          item.winnerUser = this.statusService.isWinner({
            status: data.status,
          });
          item.soldUser =
            this.statusService.isSold({ status: data.status }) ||
            item.make_an_offer?.item_has_accepted_offer;
          item.unSold = this.statusService.isNotSold({ status: data.status });
          // BXS-3591 / Issue 1: the horse just closed in real time. Its
          // previously-loaded make_an_offer window was computed while the horse
          // was still active (a small positive time_window_days), so leaving it
          // stale makes the card render a premature, disabled "Make an Offer"
          // button. Zero the window so the button hides until the next refetch
          // restores the authoritative, buyer-specific offer availability.
          item.make_an_offer = {
            ...(item.make_an_offer || {}),
            is_available: false,
            time_window_days: 0,
          };
        }

        // Update display_price from backend (already formatted)
        if (data.display_price !== undefined) {
          item.display_price = data.display_price;
        }

        // Update buyer_name from backend (already masked if needed)
        if (data.buyer_name !== undefined) {
          item.buyer_name = data.buyer_name;
        }

        // Update winner info
        if (data.winner) {
          item.winner = data.winner;
        }

        // Update bid amounts
        if (data.bids?.highest_bid !== undefined) {
          item.highest_bid_amount = data.bids.highest_bid;
        }

        // Update individual item end date from Pusher
        if (data?.auction_item_end_date) {
          item.extended_end_date = data.auction_item_end_date;
        }

        // BXS-3591: Re-sort after a status change. The backend's
        // `sorted_auction_items_ids` (handled above) is now consistent with the
        // displayed status, but we still run the local sort unconditionally
        // during gradual ending so a card whose countdown just hit zero moves to
        // the end immediately — even in the brief window where this backend
        // event was built a moment before the server clock crossed the item's
        // end time (clock skew / event in flight).
        this.sortCatalogDuringGradualEnding();

        // Trigger change detection
        this.catalogData = [...this.catalogData];
        this.cdr.detectChanges();

        this.notification.showNotification('Auctions Update', {
          body: ``,
          icon: 'assets/images/x-logo.png',
        });
      }
    }
  }
  handleTimeEnded(item: IHorse, type: string) {
    if (!this.isCardLayout && type == 'list') {
      const index = this.catalogData.findIndex((el) => el?.id == item?.id);
      if (index != -1) {
        this.catalogData[index].can_bid = false;
        // BXS-3591: mark the item as locally expired so the gradual-ending
        // sort moves it to the end of the table immediately, without waiting
        // for the Pusher event or the rollover refresh.
        this.catalogData[index]._localExpired = true;
        this.sortCatalogDuringGradualEnding();
        this.scheduleRolloverFallback();
      }
    }
  }

  onCardTimerEnded(auctionItemId?: number): void {
    const item = this.catalogData.find((el) => el?.id == auctionItemId);
    if (item) {
      item.can_bid = false;
      // BXS-3591: same as handleTimeEnded above — the local card timer
      // reached zero so we flag the item, then re-sort the catalogue so the
      // closed card moves to the end immediately.
      item._localExpired = true;
    }
    this.sortCatalogDuringGradualEnding();
    this.scheduleRolloverFallback();
  }
  openBidIncrements() {
    this.dialog.open(BidIncrementsComponent, {
      direction: this.localeService.dir,
      panelClass: ['buyer-theme'],

      // width: '400px',
      // data: { bidsIncrements: this.bidsIncrements },
    });
  }
  getRowClass = (row: any) => {
    return {
      'withdraw-horse': row.withdrawn_at != null,
    };
  };
  rowClicked(item: any) {
    this.router.navigate(
      ['/buyer/auctions', item?.aucSlug, 'horse', item?.slug],
      {
        state: { auctionTypePage: this.auctionTypeParams },
        queryParams: {
          type: 'catalogue',
        },
      },
    );
  }
  goToTermsAndConditions() {
    const url = `/terms-and-conditions/auction/${this.auction?.id}`;
    window.open(url, '_blank');
  }

  cardClicked(item: any) {
    this.router.navigate(
      ['/buyer/auctions', item.aucSlug, 'horse', item.slug],
      {
        state: { auctionTypePage: this.auctionTypeParams },
        queryParams: {
          type: 'catalogue',
        },
      },
    );
  }

  toggleLayout() {
    this.isCardLayout = !this.isCardLayout; // Toggle between card and table layout
    setTimeout(() => {
      this.subscribeToOfferUpdatesChannel();
      this.subscribeToBuyerApplicationsChannels();
      this.subscribeToPrivateTermsAndConditionsUpdated();
    }, 500);
  }
  openCatalogueStats() {
    this.dialog.open(CatalogueStatsDialogComponent, {
      direction: this.localeService.dir,
      width: '400px',
      panelClass: ['buyer-theme'],

      data: {
        translations: this.catalogueTranslation,
        stats: this.auction?.sales_statistics,
      },
    });
  }
  //////////////////PUSHER SUBSCRIPTIONS/////////////////////
  buyerApplicationsEvents: any[] = [
    {
      events: [
        {
          eventName: Events.BUYER_APP_ACCEPTED,
          showNot: true,
          pushTitle: 'Status Update',
          accepted: true,
        },

        {
          eventName: Events.BUYER_APP_REJECTED,
          showNot: true,
          pushTitle: 'Status Update',
          accepted: false,
        },
      ],
    },
  ];
  subscribeToOfferUpdatesChannel() {
    const eventName = 'item_offer.updated';
    this.boundPrivateEvents.push(eventName);
    this.pusherService.subscribeToPrivateChannel(
      'private-user.{user_id}',
      eventName,
      true,
      'Offer Updated',
      (data: any) => {
        const item = this.catalogData.find(
          (el) => el?.id == data.auction_item_id,
        );
        if (item) {
          this.getData(false);
        }
      },
    );
  }
  subscribeToBuyerApplicationsChannels() {
    this.buyerApplicationsEvents.forEach((channelConfig) => {
      channelConfig.events.forEach(
        (event: {
          eventName: string;
          showNot: boolean;
          pushTitle: string;
          accepted: boolean;
        }) => {
          // Track bound event for cleanup
          this.boundPrivateEvents.push(event.eventName);
          this.pusherService.subscribeToPrivateChannel(
            'private-user.{user_id}', // Template channel name
            event.eventName,
            event.showNot,
            event.pushTitle,
            (data: {
              auction_ids: any;
              buyer_user_id: number;
              seller_id: number;
            }) => {
              if (data?.auction_ids) {
                if (data?.auction_ids.includes(this.auctionId)) {
                  this.auctionSettings = changeAuctionItemStatus(
                    event.accepted,
                    this.auctionSettings,
                  );
                  if (event.accepted) {
                    this.getData(false);
                  }
                }
              }
            },
          );
        },
      );
    });
  }
  auctionItemUpdateDebouncing() {
    this.subscriptions.push(
      this.auctionItemUpdateSubject
        .pipe(
          debounceTime(500), // Wait 300ms after the last emission
          distinctUntilChanged((prev, curr) => {
            // Create a comparison key that ignores timestamp differences
            const prevKey = `${prev.auction_item_id}-${
              prev.auction_id
            }-${JSON.stringify(prev.bids)}-${JSON.stringify(prev.status)}`;
            const currKey = `${curr.auction_item_id}-${
              curr.auction_id
            }-${JSON.stringify(curr.bids)}-${JSON.stringify(curr.status)}`;

            const isDuplicate = prevKey === currKey;
            // if (isDuplicate) {
            //   console.log('Duplicate event filtered out by distinctUntilChanged');
            // }
            return isDuplicate;
          }),
        )
        .subscribe((data) => {
          this.handleAuctionUpdate(data);
        }),
    );
  }
  pendingUpdates: any;
  subscribeToAuctionItemUpdated() {
    if (this.isSubscribed) {
      return;
    }
    // Track the public event for cleanup
    this.boundPublicEvents.push('auction_item.updated');

    // Subscribe to the Observable returned by the service
    const subscription = this.pusherSubscriptionService
      .getAuctionItemUpdates$()
      .subscribe((data) => {
        // Push to subject instead of handling directly
        this.auctionItemUpdateSubject.next(data);
      });

    // Store subscription for cleanup
    this.subscriptions.push(subscription);
    this.isSubscribed = true;
  }
  subscribeToAuctionItemUpdatesUpdated() {
    // Track the public event for cleanup
    this.boundPublicEvents.push('horse_update.updated');

    // Subscribe to the Observable returned by the service
    const subscription = this.pusherSubscriptionService
      .getHorseUpdates$()
      .subscribe((data: any) => {
        const item = this.catalogData.find(
          (el) => el?.id == data.auction_item_id,
        );
        if (item) {
          this.rolloverRefreshCoordinator.cancelFallbackOnRealtimeUpdate(
            this.auctionId,
          );
          this.getData(false);
        }
      });

    // Store subscription for cleanup
    this.subscriptions.push(subscription);
  }
  subscribeToPrivateTermsAndConditionsUpdated() {
    // Track the private event for cleanup
    this.boundPrivateEvents.push('terms-and-conditions.updated');
    this.pusherSubscriptionService.subscribeToPrivateTermsAndConditionsUpdated(
      (data: any) => {
        if (data?.affected_auctions?.includes(this.auctionId)) {
          this.auction.seller_terms = data?.terms_and_conditions;
          this.auction.buyer_accepted_seller_terms = 'not accepted';
        }
      },
    );
  }
  private unsubscribeAllPusherEvents() {
    this.pusherSubscriptions.forEach((subscription) => {
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
    this.pusherSubscriptions = [];
    this.isSubscribed = false;
  }

  unSubscribeToPrivateUserChannel() {
    this.pusherService.unsubscribeFromPrivateChannel();
  }
  unSubscribeToPublicUserChannel() {
    this.pusherService.unsubscribeFromPublicChannel();
  }

  private scheduleRolloverFallback(): void {
    const now = Date.now();
    if (now - this.lastRefreshTimestamp < this.REFRESH_COOLDOWN_MS) {
      return; // Skip if we recently refreshed to prevent rapid loops during gradual ending
    }
    this.lastRefreshTimestamp = now;
    this.rolloverRefreshCoordinator.scheduleFallbackRefresh(
      () => {
        this.lastRefreshTimestamp = Date.now();
        this.getData(false);
      },
      this.auctionId,
    );
  }

  get activeFilters(): number {
    // Count from dynamicFilters which stores the actual selected values
    return Object.values(this.dynamicFilters).filter((values) => {
      if (Array.isArray(values) && values.length > 0) {
        const firstValue = values[0];
        // For text fields, check if non-empty string
        if (typeof firstValue === 'string') {
          return firstValue.trim() !== '';
        }
        // For select/multiselect, any value means active
        return true;
      }
      return false;
    }).length;
  }

  get hasActiveFilters(): boolean {
    return this.activeFilters > 0;
  }

  private calculateTotalResults(): number {
    if (Object.keys(this.staticFilters).length === 0) return 0;
    // Sum counts from the first available filter
    const firstFilterKey = Object.keys(
      this.staticFilters,
    )[0] as keyof StaticFilters;
    const firstFilter = this.staticFilters[firstFilterKey];
    if (!firstFilter) return 0;
    return firstFilter.reduce(
      (sum: number, item: any) => sum + (item.count || 0),
      0,
    );
  }

  toggleFilters(): void {
    this.isExpanded = !this.isExpanded;
  }

  clearAllFilters(): void {
    this.filterFields.forEach((field) => {
      field.value = [];
    });
  }

  updateFilters(newFilters: any): void {
    this.saveScrollPosition();

    const queryParams: any = {
      page: 1,
      search: this.searchVal,
    };

    Object.entries(newFilters).forEach(([key, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        // Single-select: use the last value
        const value = values[values.length - 1];
        if (value && value !== '') {
          // search_term is sent directly, other filters use filters[key] format
          if (key === 'search_term') {
            queryParams['search_term'] = value;
          } else {
            queryParams[`filters[${key}]`] = value;
          }
          this.dynamicFilters[key] = [value];
        }
      }
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
    });
  }
  // Helper method to create a map of field types
  private getFieldTypesMap(): { [key: string]: string } {
    return this.filterFields.reduce((acc: { [key: string]: string }, field) => {
      acc[field.key] = field.type;
      return acc;
    }, {});
  }

  onFiltersChanged(filters: any): void {
    this.updateFilters(filters);

    setTimeout(() => {
      this.restoreScrollPosition(); // Restore after updating
    }, 1);
  }

  /**
   * Update table headers and breadcrumbs with current translations
   * Called automatically when language changes
   */
  private updateTranslations(): void {
    if (this.tableColumns.length === 0) return;

    const bidCol =
      this.auctionType == 'upcoming'
        ? 'horse_info.starting_bid'
        : this.auctionType == 'previous'
          ? 'horse_info.latest_bid'
          : 'horse_info.current_bid';

    this.tableColumns.forEach((column) => {
      switch (column.translationKey) {
        case 'horse_info_hip':
          column.header = this.languageService.instant('horse_info.hip');
          break;
        case 'horse_info_name':
          column.header = this.languageService.instant('horse_info.name');
          break;
        case 'horse_info_sire':
          column.header = this.languageService.instant('horse_info.sire');
          break;
        case 'horse_info_dam':
          column.header = this.languageService.instant('horse_info.dam');
          break;
        case 'horse_info_born':
          column.header = this.languageService.instant('horse_info.born');
          break;
        case bidCol.replace('.', '_'):
          column.header = this.languageService.instant(bidCol);
          break;
        case 'horse_info_actions':
          column.header = this.languageService.instant('horse_info.actions');
          break;
      }
    });

    // Update breadcrumbs
    if (this.breadcrumbs && this.breadcrumbs.length > 0) {
      this.breadcrumbs[0].label = this.languageService.instant(
        'buyer_catalogue.home',
      );
      this.breadcrumbs[1].label =
        this.auctionTypeParams !== 'my_auctions'
          ? this.languageService.instant('buyer_catalogue.auctions')
          : this.languageService.instant('buyer_catalogue.my_auctions');

      if (this.auction?.name) {
        this.breadcrumbs[2].label =
          this.localizedNamePipe.transform(this.auction.name) +
          ' ' +
          this.languageService.instant('buyer_catalogue.catalogue');
      } else {
        this.breadcrumbs[2].label = this.languageService.instant(
          'buyer_catalogue.catalogue',
        );
      }
    }

    // Defer change detection to next cycle
    setTimeout(() => this.cdr.detectChanges(), 0);
  }

  ngOnDestroy(): void {
    this.rolloverRefreshCoordinator.dispose();

    // Clean up all RxJS subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];

    // Complete all Subjects to notify subscribers and prevent memory leaks
    this.auctionItemUpdateSubject.complete();
    this.isLoadingState.complete();
    this.selectedFilters.complete();

    // Clean up Pusher subscriptions
    this.unsubscribeAllPusherEvents();

    // Unbind private channel events
    this.unbindPrivateChannelEvents();

    // Clean up translation updater
    if (this.translationUpdater) {
      this.translationUpdater.destroy();
    }

    // Clear any pending timers
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  /**
   * Unbind all private channel events that were bound in this component
   */
  private unbindPrivateChannelEvents(): void {
    if (this.user_id && this.boundPrivateEvents.length > 0) {
      const channelName = `private-user.${this.user_id}`;
      this.boundPrivateEvents.forEach((eventName) => {
        this.pusherService.unbindEvent(channelName, eventName);
      });
      this.boundPrivateEvents = [];
    }

    // Unbind public channel events
    if (this.boundPublicEvents.length > 0) {
      this.boundPublicEvents.forEach((eventName) => {
        this.pusherService.unbindEvent('public-auction', eventName);
      });
      this.boundPublicEvents = [];
    }
  }
}
